import React from 'react';
import { Card, Typography } from 'antd';
import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  Title as ChartTitle
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend, ChartTitle);

const { Title } = Typography;

interface RevenueBreakdownData {
  labels: string[];
  datasets: Array<{
    label?: string;
    data: number[];
    backgroundColor?: string[];
    borderColor?: string[];
    borderWidth?: number;
  }>;
}

interface RevenueBreakdownChartProps {
  data?: RevenueBreakdownData;
  title?: string;
  height?: number;
}

const defaultData: RevenueBreakdownData = {
  labels: ['產品A', '產品B', '產品C', '產品D', '其他'],
  datasets: [
    {
      label: '營收佔比',
      data: [35, 25, 20, 15, 5],
      backgroundColor: [
        'rgba(255, 99, 132, 0.8)',
        'rgba(54, 162, 235, 0.8)',
        'rgba(255, 205, 86, 0.8)',
        'rgba(75, 192, 192, 0.8)',
        'rgba(153, 102, 255, 0.8)',
      ],
      borderColor: [
        'rgba(255, 99, 132, 1)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 205, 86, 1)',
        'rgba(75, 192, 192, 1)',
        'rgba(153, 102, 255, 1)',
      ],
      borderWidth: 2,
    },
  ],
};

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'right' as const,
      labels: {
        padding: 20,
        usePointStyle: true,
      }
    },
    tooltip: {
      callbacks: {
        label: function(context: any) {
          const label = context.label || '';
          const value = context.raw || 0;
          const total = context.dataset.data.reduce((a: number, b: number) => a + b, 0);
          const percentage = ((value / total) * 100).toFixed(1);
          return `${label}: ${value}% (${percentage}%)`;
        }
      }
    }
  },
};

const RevenueBreakdownChart: React.FC<RevenueBreakdownChartProps> = ({ 
  data = defaultData, 
  title = "營收結構分析",
  height = 400 
}) => {
  return (
    <Card title={title} className="revenue-breakdown-chart">
      <div style={{ height: `${height}px`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Doughnut data={data} options={chartOptions} />
      </div>
    </Card>
  );
};

export default RevenueBreakdownChart;
